<template>
  <div>
    <m-table-settings-positions
      v-model="isShowTableSettingsModal"
      :is-grouped="tableData.isGroupByCategory"
      :columns="tableData.columns"
      :disabled-columns="tableData.disabledColumns"
      :default-disabled-columns="tableData.defaultDisabledColumns"
      :is-driver-table-settings="codeGroup === 'driver'"
      with-grouped
      @submit="submitTableSettings"
    />
    <div class="positions-production">
      <div class="positions-production__wrapper">

        <div class="positions-production__actions">
          <c-switcher v-model="selectedPositionStatus" class="h-switcher" type="group" :items="positionStatuses" />

          <div class="positions-production__actions__buttons-block">
            <div class="positions-production__actions__buttons-block-item">
              <c-button
                responsive
                :disabled="isTableLoad || tableData.activeFilteredColumns.length === 0"
                label="Сбросить фильтры столбцов"
                :icon="{ color: 'pink', icon: 'filter-drop' }"
                type="with-icon"
                @click="resetColumnFilters"
              />
            </div>

            <div class="positions-production__actions__buttons-block-item">
              <c-button
                :disabled="shouldDisableSettingsButton"
                responsive
                label="Настроить столбцы"
                icon="cog"
                type="with-icon"
                @click="isShowTableSettingsModal = true"
              />
            </div>
          </div>
        </div>

        <div class="positions-production__table">
          <c-loader v-if="isTableLoad" label="Загрузка данных" :active="isTableLoad" height="300" />
          <c-data-table-positions
            v-if="!isTableLoad"
            ref="table"
            class="positions-production-table"
            :class="{
              'positions-production__table-empty': tableData.columns.length === 0 && tableData.records.length === 0,
            }"
            :empty-records-label="'Должности не найдены'"
            :data="tableData"
            :sorted-column="tableData.sortedColumn"
            :disabled-columns="tableData.disabledColumns"
            :filtered-columns="tableData.filteredColumns"
            :active-filtered-columns="tableData.activeFilteredColumns"
            :all-groups="allGroups"
            :levels="1"
            :reference-list="referenceFilterList"
            @sortedEvent="sortedTableAction"
            @getReferenceValues="setColumnReferenceFilterList"
            @removePost = "removePost"
            @changeArchiveStatus = "changeArchiveStatus"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Button from "@/components/controls/button";
import DataTablePositions from "@/pages/positions/data-table/data-table-positions";
import Loader from "@/components/loader";
import TableSettingsPositionsModal from "@/pages/positions/data-table/table-settings-positions";
import Switcher from "@/components/controls2/Switcher";

const positionStatuses = [
  {
    label: "Все",
    value: "all",
  },
  {
    label: "Активные",
    value: "active",
  },
  {
    label: "В архиве",
    value: "archived",
  },
];

export default {
  name: "positions-production",

  components: {
    "c-button": Button,
    "c-data-table-positions": DataTablePositions,
    "c-loader": Loader,
    "m-table-settings-positions": TableSettingsPositionsModal,
    "c-switcher": Switcher,
  },

  props: ["allGroups", "enabledGlobalFilters", "allGlobalFilters"],

  data() {
    return {
      codeGroup: this.$route.params.code !== undefined ? this.$route.params.code : "driver",
      referenceFilterList: [],
      tableData: {
        columns: [],
        records: [],
        disabledColumns: [],
        sortedColumn: {
          sortBy: this.$route.query.sortBy ? this.$route.query.sortBy : "created",
          sortType: this.$route.query.sortType ? this.$route.query.sortType : "desc",
        },
        defaultDisabledColumns: [],
        filteredColumns: [],
        activeFilteredColumns: [],
        activeFilteredColumnsQueryLocal: null,
        actions: true,
        isGroupByCategory: false,
        globalFilters: [],
        globalFiltersQueryLocal: null,
        currentGroup: null,
      },
      isTableLoad: false,
      isShowTableSettingsModal: false,
      defaultEnabledColumnsGroupDriver: [
        "name",
        "costPerMinute",
        "oneOrderShippingCost",
        "oneKilometerCost",
        "shiftCompletionTime",
        "mileageLimit",
        "depositAmount",
      ],
      defaultEnabledColumnsGroup: [
        "code",
        "name",
        "loadType",
        "productionRate",
        "premiumRate",
        "penaltyRate",
        "processingAmount",
        "minShiftDuration",
        "minRevenuePerHour",
        "maxSalaryReduction",
        "maxSalaryIncrease",
        "depositAmount",
        "is_vacant"
      ],
      positionStatuses,
      selectedPositionStatus: "active",
    };
  },

  computed: {
    ...mapGetters("positions", [
      "getColumnsTableForGroup",
      "getCategoriesTableForGroup",
      "getUserColumnsTableForGroup",
    ]),
    shouldDisableSettingsButton() {
      return (
        this.tableData.globalFilters.length === 0 &&
        this.tableData.activeFilteredColumns.length === 0 &&
        this.tableData.records.length === 0
      );
    },
  },

  watch: {
    selectedPositionStatus() {
      this.updateTable();
    },

    "getUserColumnsTableForGroup": function (value) {
      if (value.columns !== undefined) {
        const disabledColumns = this.tableData.columns.filter((item) => !value.columns.includes(item.id));

        this.tableData.disabledColumns = disabledColumns.map((item) => item.id);
      }
    },

    "tableData.activeFilteredColumns": function (filters) {
      if (!this.isTableLoad) {
        const queryFilters = filters.reduce((acc, item) => {
          let currentFilter;
          if (item.type === "list") {
            currentFilter = {
              [item.id]: item.value.map((i) => i.id).join(","),
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          } else if (item.type === "number" && item.searchType === "4") {
            currentFilter = {
              [item.id]: `${item.value.start},${item.value.end}`,
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          } else if (item.type === "boolean") {
            currentFilter = {
              [item.id]: item.value,
              [`${item.id}_filterType`]: item.type,
            };
          } else {
            currentFilter = {
              [item.id]: item.value,
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          }
          return { ...acc, ...currentFilter };
        }, {});

        this.tableData.activeFilteredColumnsQueryLocal = { ...queryFilters };

        this.updateTable();
      }
    },

    "enabledGlobalFilters": function (value) {
      const activeGlobalFilters = [];

      value.forEach((item) => {
        const c = activeGlobalFilters.findIndex((i) => i.id === item.id);

        if (c === -1 && item.type === "number" && item.searchType === "4" && item.value.end !== 0) {
          activeGlobalFilters.push(item);
        }

        if (c !== -1 && item.type === "number" && item.searchType === "4" && item.value.end !== 0) {
          activeGlobalFilters[c] = item;
        }

        if (c === -1 && item.type === "boolean" && item.value) {
          activeGlobalFilters.push(item);
        }

        if (c !== -1 && item.type === "boolean") {
          if (item.value.toString() === "1") {
            activeGlobalFilters[c] = item;
          }
          if (item.value.toString() === "0") {
            activeGlobalFilters.splice(c, 1);
          }
        }

        if (c !== -1 && item.value.length === 0 && item.type !== "boolean") {
          activeGlobalFilters.splice(c, 1);
        } else if (c !== -1 && item.value.length > 0 && item.type !== "boolean") {
          activeGlobalFilters[c] = item;
        } else if (c === -1 && item.value.length > 0 && item.type !== "boolean") {
          activeGlobalFilters.push(item);
        }
      });

      this.tableData.globalFilters = [...activeGlobalFilters];
    },

    "tableData.globalFilters": function (value) {
      if (!this.isTableLoad) {
        const queryFilters = value.reduce((acc, item) => {
          let currentFilter;
          if (item.type === "list") {
            currentFilter = {
              [item.id]: item.value.map((i) => i.id).join(","),
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType ? "2" : "1",
            };
          } else if (item.type === "number" && item.searchType === "4") {
            currentFilter = {
              [item.id]: `${item.value.start},${item.value.end}`,
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          } else if (item.type === "boolean") {
            if (item.value === "1") {
              currentFilter = {
                [item.id]: item.value,
                [`${item.id}_filterType`]: item.type,
              };
            }
          } else {
            currentFilter = {
              [item.id]: item.value,
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          }
          return { ...acc, ...currentFilter };
        }, {});

        this.tableData.globalFiltersQueryLocal = queryFilters;

        const fullQuery = {
          sortBy: this.tableData.sortedColumn.sortBy,
          sortType: this.tableData.sortedColumn.sortType,
          ...queryFilters,
          ...this.tableData.activeFilteredColumnsQueryLocal,
        };

        if (JSON.stringify(this.$route.query) !== JSON.stringify(fullQuery)) {
          this.updateTable();
        }
      }
    },
  },

  async created() {
    if (Object.keys(this.$route.query).length==0) {
      let query = localStorage.getItem("filters_positions");
      if (query) {
        let p = localStorage.getItem("params_positions");
        query=JSON.parse(query);
        if (p) p=JSON.parse(p);
        this.$router
          .replace({
            name: "positions",
            params: { code: p },
            query,
          })
          .catch(() => {});
      }
    }
    if (this.$route.params.code === undefined) {
      this.isTableLoad = true;
      setTimeout(() => {
        const [group] = this.allGroups;
        if (group) {
          this.$router.replace({ name: "positions", params: { code: group.code } });
        }
        this.updateTable(true);
      }, 1000);
    } else {
      this.updateTable(true);
    }
  },

  methods: {
    storageFilters() {
      localStorage.setItem("filters_positions", JSON.stringify(this.$route.query));
      localStorage.setItem("params_positions", JSON.stringify(this.$route.params.code));
    },

    removePost() {
      this.updateTable();
    },

    submitTableSettings(disabledColumns, withGrouped) {
      let enabledColumns = this.tableData.columns.filter((item) => !disabledColumns.includes(item.id));

      enabledColumns = enabledColumns.map((item) => item.id);

      this.isTableLoad = true;
      this.$store.dispatch("positions/saveUserColumns", [this.codeGroup, enabledColumns, withGrouped]).then(() => {
        this.updateTable();
      });
    },

    setGlobalFilters() {
      this.allGlobalFilters.forEach((field) => {
        if (this.$route.query[field.code] !== undefined) {
          let filterOptions;
          if (this.$route.query[`${field.code}_filterType`] === "list") {
            const values = this.$route.query[field.code].split(",").map((item) => ({ id: item }));
            filterOptions = {
              id: field.code,
              type: this.$route.query[`${field.code}_filterType`],
              searchType: this.$route.query[`${field.code}_searchType`],
              value: values,
            };
          } else if (
            this.$route.query[`${field.code}_filterType`] === "number" &&
            this.$route.query[`${field.code}_searchType`] === "4"
          ) {
            const values = this.$route.query[field.code].split(",");
            const rangeVal = { start: values[0], end: values[1] };
            filterOptions = {
              id: field.code,
              type: this.$route.query[`${field.code}_filterType`],
              searchType: this.$route.query[`${field.code}_searchType`],
              value: rangeVal,
            };
          } else if (this.$route.query[`${field.code}_filterType`] === "boolean") {
            filterOptions = {
              id: field.code,
              type: this.$route.query[`${field.code}_filterType`],
              value: this.$route.query[field.code],
            };
          } else {
            filterOptions = {
              id: field.code,
              type: this.$route.query[`${field.code}_filterType`],
              searchType: this.$route.query[`${field.code}_searchType`],
              value: this.$route.query[field.code],
            };
          }
          this.tableData.globalFilters.push(filterOptions);
        }
      });

      const globalQueryFilters = this.tableData.globalFilters.reduce((acc, item) => {
        let currentFilter;
        if (item.type === "list") {
          currentFilter = {
            [item.id]: item.value.map((i) => i.id).join(","),
            [`${item.id}_filterType`]: item.type,
            [`${item.id}_searchType`]: item.searchType,
          };
        } else if (item.type === "number" && item.searchType === "4") {
          currentFilter = {
            [item.id]: `${item.value.start},${item.value.end}`,
            [`${item.id}_filterType`]: item.type,
            [`${item.id}_searchType`]: item.searchType,
          };
        } else if (item.type === "boolean") {
          if (item.value === "1") {
            currentFilter = {
              [item.id]: item.value,
              [`${item.id}_filterType`]: item.type,
            };
          }
        } else {
          currentFilter = {
            [item.id]: item.value,
            [`${item.id}_filterType`]: item.type,
            [`${item.id}_searchType`]: item.searchType,
          };
        }
        return { ...acc, ...currentFilter };
      }, {});

      this.tableData.globalFiltersQueryLocal = globalQueryFilters;
    },

    updateTable(isFirstLoadPage = false) {
      this.isTableLoad = true;

      this.$store.dispatch("positions/getColumnsTableForGroup", this.codeGroup).then((res) => {
        if (isFirstLoadPage) {
          this.setGlobalFilters();
        }

        this.tableData.filteredColumns = [];

        const columnList = Array.isArray(res.items) ? res.items : [];

        this.tableData.columns = columnList
          .map((column) => {
            let unit = "";

            if (column.unit === "ruble") {
              unit = ", ฿";
            } else if (column.unit === "km") {
              unit = ", км";
            }

            if (column.data_type !== undefined && column.data_type !== null) {
              this.tableData.filteredColumns.push(column.code);

              if (this.$route.query[column.code] !== undefined && isFirstLoadPage) {
                let filterOptions;
                if (this.$route.query[`${column.code}_filterType`] === "list") {
                  const values = this.$route.query[column.code].split(",").map((item) => ({ id: item }));
                  filterOptions = {
                    id: column.code,
                    type: this.$route.query[`${column.code}_filterType`],
                    searchType: this.$route.query[`${column.code}_searchType`],
                    value: values,
                  };
                } else if (
                  this.$route.query[`${column.code}_filterType`] === "number" &&
                  this.$route.query[`${column.code}_searchType`] === "4"
                ) {
                  const values = this.$route.query[column.code].split(",");
                  const rangeVal = { start: values[0], end: values[1] };
                  filterOptions = {
                    id: column.code,
                    type: this.$route.query[`${column.code}_filterType`],
                    searchType: this.$route.query[`${column.code}_searchType`],
                    value: rangeVal,
                  };
                } else {
                  filterOptions = {
                    id: column.code,
                    type: this.$route.query[`${column.code}_filterType`],
                    searchType: this.$route.query[`${column.code}_searchType`],
                    value: this.$route.query[column.code],
                  };
                }
                this.tableData.activeFilteredColumns.push(filterOptions);
              }
            }

            return {
              id: column.code,
              label: column.short_name + unit,
              fullName: column.name + unit,
              type: column.data_type ? column.data_type : undefined,
              description: column.description ? column.description : undefined,
              parentColumnId: column.parent_column ? column.parent_column : undefined,
              level: column.level,
              isCategory: 0,
              characteristic: column.characteristic,
              isSorted: column.code === this.tableData.sortedColumn.sortBy,
            };
          })
          .filter((column) => column.id !== "additionalLoad");

        const findIndexCurrentSortedColumnInTableColumns = this.tableData.columns
          .map((col) => col.id)
          .findIndex((id) => id === this.tableData.sortedColumn.sortBy);

        if (findIndexCurrentSortedColumnInTableColumns === -1) {
          this.tableData.sortedColumn.sortBy = "created";
          this.tableData.sortedColumn.sortType = "desc";
        }

        const queryFilters = this.tableData.activeFilteredColumns.reduce((acc, item) => {
          let currentFilter;
          if (item.type === "list") {
            currentFilter = {
              [item.id]: item.value.map((i) => i.id).join(","),
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          } else if (item.type === "number" && item.searchType === "4") {
            currentFilter = {
              [item.id]: `${item.value.start},${item.value.end}`,
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          } else if (item.type === "boolean") {
            currentFilter = {
              [item.id]: item.value,
              [`${item.id}_filterType`]: item.type,
            };
          } else {
            currentFilter = {
              [item.id]: item.value,
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          }
          return { ...acc, ...currentFilter };
        }, {});

        this.tableData.activeFilteredColumnsQueryLocal = { ...queryFilters };

        this.tableData.defaultDisabledColumns =
          this.codeGroup === "driver"
            ? this.tableData.columns.filter((col) => this.defaultEnabledColumnsGroupDriver.indexOf(col.id) === -1)
            : this.tableData.columns.filter((col) => this.defaultEnabledColumnsGroup.indexOf(col.id) === -1);

        this.$store.dispatch("positions/getUserColumnsTableForGroup", this.codeGroup).then((userColumnsRes) => {
          const additional = userColumnsRes.additional || { groupByCategory: 0 };
          this.tableData.isGroupByCategory =
            additional.groupByCategory && additional.groupByCategory.toString() === "1";

          this.$store
            .dispatch("positions/getCategoriesTableForGroup", {
              groupId: this.codeGroup,
              filtersLocal: this.tableData.activeFilteredColumns,
              filtersGlobal: this.tableData.globalFilters,
              selectedPositionStatus: this.selectedPositionStatus,
            })
            .then((categoriesRes) => {
              const records = [];
              const categoryItemList = categoriesRes.items || [];

              if (this.tableData.isGroupByCategory) {
                Object.entries(categoryItemList).forEach(([categoryName, category]) => {
                  if (category.posts !== undefined) {
                    const categoryRecords = [];
                    category.posts.forEach((post) => {
                      let mapRec = {};
                      Object.entries(post).forEach(([key, value]) => {
                        mapRec = { ...mapRec, [key]: { value: value === "null" ? undefined : value } };
                      });
                      mapRec = { ...mapRec, isShowRow: true };
                      delete mapRec.categoryName;
                      delete mapRec.type_post;
                      categoryRecords.push(mapRec);
                    });
                    records.push({ categoryName, records: categoryRecords });
                  }
                });
              } else if (Array.isArray(categoryItemList)) {
                categoryItemList.forEach((post) => {
                  let mapRec = {};
                  Object.entries(post).forEach(([key, value]) => {
                    mapRec = { ...mapRec, [key]: { value: value === "null" ? undefined : value } };
                  });
                  mapRec = { ...mapRec, isShowRow: true };
                  delete mapRec.categoryName;
                  delete mapRec.type_post;
                  records.push(mapRec);
                });
              }

              this.tableData.records = [...records];

              const fullQuery = {
                sortBy: this.tableData.sortedColumn.sortBy,
                sortType: this.tableData.sortedColumn.sortType,
                ...this.tableData.activeFilteredColumnsQueryLocal,
                ...this.tableData.globalFiltersQueryLocal,
              };

              this.$router
                .replace({
                  name: "positions",
                  query: fullQuery,
                })
                .catch(() => {});
              this.storageFilters();

              const indexCurrentGroup = this.allGroups.findIndex((group) => group.code === this.codeGroup);
              if (indexCurrentGroup !== -1) {
                this.tableData.currentGroup = this.allGroups[indexCurrentGroup];
              } else if (this.codeGroup) {
                this.tableData.currentGroup = { code: this.codeGroup, name: this.codeGroup };
              }

              this.isTableLoad = false;
            })
            .catch(() => {
              this.tableData.records = [];
              this.isTableLoad = false;
            });
        })
          .catch(() => {
            this.isTableLoad = false;
          });
      })
        .catch(() => {
          this.tableData.columns = [];
          this.tableData.records = [];
          this.isTableLoad = false;
        });
    },

    sortedTableAction() {
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query));
      currentQuery.sortBy = this.tableData.sortedColumn.sortBy;
      currentQuery.sortType = this.tableData.sortedColumn.sortType;

      this.$router
        .replace({
          name: "positions",
          params: { code: this.codeGroup },
          query: currentQuery,
        })
        .catch(() => {});
      this.storageFilters();
    },

    resetColumnFilters() {
      this.tableData.activeFilteredColumns = [];
    },

    setColumnReferenceFilterList() {
      this.$store.dispatch("positions/getTypeLoadReference").then((result) => {
        this.referenceFilterList = result.items.map((item) => ({ id: item.code, value: item.code, label: item.name }));
      });
    },

    changeArchiveStatus(record) {
      console.log('record', record);
      this.$notify({
        group:  "success-message",
        data: {
          textMessage: 'message',
        },
      });
      this.updateTable();
    }
  },
};
</script>

<style lang="scss" scoped>
.positions-production {
  &__wrapper {
    position: relative;
    margin-top: 22px;

    ::v-deep .c-table__wrapper > .ps__rail-x {
      z-index: 351;
      background: #ffffff !important;
    }

    ::v-deep .c-table__wrapper > .ps__rail-x:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(-30px, 0);
      box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
      z-index: -1;
      height: 24px;
      width: calc(100vw - 60px);
      background: #ffffff;
    }

    ::v-deep .c-table__wrapper > .ps__rail-x:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(0, calc(-50% + 1px));
      border-radius: 10px;
      z-index: -1;
      height: 4px;
      width: calc(100% - 34px);
      background: #dfe4ef;
    }
  }

  &__actions {
    display: flex;
    justify-content: space-between;

    &__buttons-block {
      display: flex;
      justify-content: flex-end;

      &-item {
        margin-left: 10px;
        margin-bottom: 23px;
      }
    }
  }

  &__table {
    /*margin-top: 23px;*/

    &-empty {
      margin-top: -20px;
    }
  }

  &-table-settings {
    &-hide-group {
    }
  }
}
</style>
